import { atom } from "recoil";

export const chatPinnedAddModalStore = atom({
	key: "chatPinnedAddModalStore",
	default: {
		show: false,
		loaded: true,
		currentOption: {
			status: [
				{ value: "enabled", label: "Enabled" },
				{ value: "disabled", label: "Disabled" },
			],
			type: [
				{ value: "permanent", label: "Permanent" },
				{ value: "interval", label: "Interval" },
			],
			messageType: [
				{ value: "local", label: "Local" },
				{ value: "international", label: "International" },
				{ value: "mixed", label: "Mixed" },
			],
		},
		message: "",
		messageType: "",
		isClickable: false,
		link: "",
		type: false,
		lastDisplayedDate: null,
		lastDisplayedTime: null,
		status: false,
		durationMinutes: 0,
		intervalMinutes: 0,
	},
});
